import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Github } from 'lucide-react';
import { SiX } from 'react-icons/si';
import logoIcon from '../../assets/logo-icon.png';
import { LEGAL_ENTITY_NAME, LEGAL_REGISTERED_ADDRESS } from '../../legalInfo';
import './FooterNew.css';

export const FooterNew = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-new">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label="Liceron home">
              <img src={logoIcon} alt="" className="footer-logo-img" aria-hidden="true" />
              <span className="footer-logo-text">LICERON</span>
            </Link>
            <p className="footer-tagline">
              Enterprise AI agent solutions. Custom-built. Production-ready.
            </p>
          </div>

          {/* Solutions */}
          <div className="footer-column">
            <h4 className="footer-heading">Solutions</h4>
            <ul className="footer-links">
              <li><Link to="/solutions/conversational-agents">Conversational Agents</Link></li>
              <li><Link to="/solutions/workflow-agents">Workflow Agents</Link></li>
              <li><Link to="/solutions/data-agents">Data Agents</Link></li>
              <li><Link to="/solutions/enterprise">Enterprise AI</Link></li>
              <li><Link to="/agent-studio">Agent Studio <span className="soon-tag">Soon</span></Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer-column">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/case-studies">Case Studies</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div className="footer-column">
            <h4 className="footer-heading">Connect</h4>
            <ul className="footer-links">
              <li><a href="mailto:sales@liceron.in">sales@liceron.in</a></li>
            </ul>
            <div className="footer-social">
              <a href="https://www.linkedin.com/company/liceron" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <Linkedin size={18} />
              </a>
              <a href="https://x.com/liceron" target="_blank" rel="noopener noreferrer" aria-label="X (formerly Twitter)">
                <SiX size={16} />
              </a>
              <a href="https://github.com/Liceron" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <Github size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-legal-entity">
          <p className="footer-legal-name">{LEGAL_ENTITY_NAME}</p>
          <p className="footer-legal-address">{LEGAL_REGISTERED_ADDRESS}</p>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Liceron. All rights reserved.</p>
          <div className="footer-legal">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
